const getCanonicalUrl = (url = '') => {
  if (!url) {
    return '';
  }

  try {
    const canonicalUrl = new URL(url);
    canonicalUrl.protocol = 'https:'; // see: https://github.com/remix-run/remix/issues/420

    return canonicalUrl.origin + canonicalUrl.pathname;
  } catch (_e) {
    return '';
  }
};

export default getCanonicalUrl;
